module.exports = __webpack_public_path__ + "static/media/playPowtoon.4af30d56.svg";